export default __webpack_public_path__ + "static/cruiselogo_cunard-2ef586db7c0e9994add03b821d5be0b4.png";